module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b1-9930ab4a9a8221b630bacad778564307.jpg";